import { useInView } from 'react-intersection-observer';
import React, { useEffect } from 'react';
export default function InfiniteScrollTrigger(_ref) {
  let {
    onTrigger
  } = _ref;
  const {
    ref,
    inView
  } = useInView();
  useEffect(() => {
    if (inView) {
      onTrigger();
    }
  }, [onTrigger, inView]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    "data-sentry-component": "InfiniteScrollTrigger",
    "data-sentry-source-file": "InfiniteScrollTrigger.tsx"
  });
}